import { IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonCol, IonContent, IonGrid, IonImg, IonPage, IonRow } from "@ionic/react";
import { FC, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { translation } from "../../models/translation";
import { fetchAllFeeds } from "../../services/feed_service";


const AllFeeds: FC = () => {

    const history = useHistory();
    const { id } = useParams<{ id: string; }>();



    const siteText = translation();

    const [lan] = useState(siteText.lan);


 


    const [feeds, setFeeds] = useState<any>(null);

    useEffect(() => {
        fetchAllFeeds().then(
            m => {
                console.log(m.message)
                setFeeds(m.message);
            }
        )
        return () => {
        };
    }, [])


    return (
        <IonPage>
            <IonContent className="ion-padding" >
                <IonGrid>
                    {
                        feeds &&
                            <>
                                <IonRow>
                                    <IonCol>
                                        <h1 className="ion-margin-start">{siteText.feedsListPageTitle}</h1>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    {
                                        !feeds ? <></> :
                                            feeds.map((relFeed: any) => {
                                                return (
                                                    <IonCol sizeXs="12" sizeSm="6" sizeMd="4" key={relFeed.id}>
                                                        <IonCard routerLink={`${lan}/account/feeds/${relFeed.id}`} className="ion-margin-bottom" key={relFeed.id} >
                                                            <IonCardHeader>
                                                                {!relFeed._embedded['wp:featuredmedia'] ? <></> :
                                                                    <IonImg src={relFeed._embedded['wp:featuredmedia'][0].source_url}></IonImg>
                                                                }
                                                                <IonCardTitle dangerouslySetInnerHTML={{__html:relFeed.title.rendered}}></IonCardTitle>
                                                                {/*!relFeed._embedded['wp:term'] ? <></> :
                                                                    <p>{relFeed._embedded['wp:term'][0][0].name}</p>
                                                            */}
                                                            </IonCardHeader>

                                                            <IonCardContent dangerouslySetInnerHTML={{ __html: relFeed.excerpt.rendered }}>
                                                            </IonCardContent>
                                                        </IonCard>
                                                    </IonCol>
                                                )
                                            })
                                    }

                                </IonRow>
                            </>
                    }

                </IonGrid>
            </IonContent>
        </IonPage >
    )

}

export default AllFeeds;